(function($) {
    "use strict";

    var CatalogDetailAction = function() {};
    CatalogDetailAction.prototype = new window.dft.ActionController();

    CatalogDetailAction.prototype.run = function() {
        window.Catwalk(window.Catwalk);
        $(document).on(
            "dft.cart-quantity.update",
            $.proxy(this, "updateTotal")
        );
        $(document).one(
            "loaded",
            "#stock-available",
            $.proxy(this, "showFreeShipping")
        );
        $(document).one(
            "loaded",
            "#product-delivery-time",
            $.proxy(this, "updateDeliveryTimeSku")
        );
        $(document).on(
            "change",
            "#add-to-cart .add-to-cart-form-sizes",
            $.proxy(this, "updateDeliveryTimeSku")
        );
        $(document).on(
            "recommendation.empty",
            "#recommendation",
            $.proxy(this, "renderTopSellers")
        );
        $("#stock-available").stockAvailable("load");
        if ($(".product-page").data("has-catwalk") == true) {
            $("#gallery").gallery("loadCatwalk");
        }
        $(document).trigger("dft.add-coupon");
        $(document).trigger("dft.fashion-selfie.load");
    };

    CatalogDetailAction.prototype.renderTopSellers = function() {
        $("#topseller")
            .attr("data-recommendations", "")
            .recommendations("load");
    };

    CatalogDetailAction.prototype.showFreeShipping = function() {
        var freeShippingEl = $("#product-delivery-time [data-free-shipping]");

        var freeShippingAmount = parseFloat(
            0 + freeShippingEl.data("amount"),
            10
        );
        var cartPrice = parseFloat($.cookie("cart_total"), 10);
        var productPrice = parseFloat(freeShippingEl.data("price"), 10);

        if (this.isFreeShipping(freeShippingAmount, cartPrice, productPrice)) {
            freeShippingEl.addClass("is-show");
        }
    };

    CatalogDetailAction.prototype.isFreeShipping = function(
        freeShippingAmount,
        cartPrice,
        productPrice
    ) {
        return cartPrice + productPrice > freeShippingAmount;
    };

    CatalogDetailAction.prototype.updateDeliveryTimeSku = function() {
        var sku = $("#add-to-cart [name=sku]").val();
        if (!sku)
            sku = $("#add-to-cart .selectbox-options :first-child").data(
                "value"
            );

        $("#product-delivery-time [data-delivery-time-form]").data("sku", sku);
    };

    $(document).on("click", ".in-popup", function() {
        var targetUrl = $(this).attr("href");
        var network = $(this)
            .parent()
            .attr("class");
        if (typeof _gaq != "undefined") {
            switch (network) {
                case "twitter":
                    _gaq.push(["_trackSocial", "twitter", "tweet", targetUrl]);
                    break;
                case "facebook":
                    _gaq.push(["_trackSocial", "facebook", "share", targetUrl]);
                    break;
                case "googleplus":
                    _gaq.push([
                        "_trackSocial",
                        "googleplus",
                        "plusone",
                        targetUrl
                    ]);
                    break;
                case "pinterest":
                    _gaq.push(
                        ["_trackSocial", "pinterest", "pinned"],
                        targetUrl
                    );
                    break;
            }
        }

        window.open(
            targetUrl,
            "social-network-window",
            "height=250,width=500,scrollbars=1"
        );
        return false;
    });

    routes["catalog/detail"] = function() {
        new CatalogDetailAction().run();
    };

    $(document).trigger("catalog/detail");

    /*
     * When mouse enter and is hovering the product image
     */
    $(document).on("mouseenter", ".catalog-page .product-image", function() {
        // data-hover-img is a parameter from product-image.
        // data-hover-img is the secondary image of a product
        if (
            $(this)
                .attr("data-hover-img")
                .indexOf("/-product") === -1
        ) {
            const hoverImg = $(this).attr("data-hover-img");
            // change the primary image to the secondary
            $(this).attr("src", hoverImg);
        }
    });

    /*
     * When mouse leave and isn't hovering the product image
     */
    $(document).on("mouseleave", ".catalog-page .product-image", function() {
        // data-original is a parameter from product-image.
        // data-original is related to primary image of a product
        if (
            $(this)
                .attr("data-hover-img")
                .indexOf("/-product") === -1
        ) {
            const originalImg = $(this).attr("data-original");
            // change the secondary image to the original
            $(this).attr("src", originalImg);
        }
    });

    $('.product-image').lazyload();
})(jQuery);
